import { FC } from 'react';
import { Stack, Title } from '@mantine/core';
import Subtitle from 'components/Subtitle';
import FieldCheckbox from './FieldCheckbox';
import FieldText from './FieldText';
import { RegistrationDto } from 'types/common';
import { useFormikContext } from 'formik';

const Food: FC = () => {
    const { values } = useFormikContext<RegistrationDto>();

    return (
        <>
            <Subtitle title="Ruoka" />
            <p>Ruokaa on tarjolla seuraavasti:</p>
            <ul>
                <li>pe pikkupurtavaa</li>
                <li>la pikkupurtavaa sekä amatimiehen tekemä päivällinen n. klo 20</li>
                <li>su pikkupurtavaa</li>
            </ul>
            <p>
                Edellä mainittu ruokatarjoilu on lanittajille ilmainen. Lisäksi järjestetään isompia omakustanteisia
                yhteistilauksia lähiravintoloihin.
            </p>
            <Title order={4}>Ruokavalio</Title>
            <Stack gap="sm">
                <FieldCheckbox name="ruokaKaikki" label="Kaikki käy" />
                <FieldCheckbox name="ruokaLaktoositon" label="Laktoositon" />
                <FieldCheckbox name="ruokaGluteeniton" label="Gluteeniton" />
                <FieldCheckbox name="ruokaMuu" label="Muu: " />
                    <FieldText
                        name="ruokaMuuKommentti"
                        title=""
                        placeholder="Muuta"
                        size="md"
                        style={{ width: 250 }}
                        disabled={!values.ruokaMuu}
                    />
                </Stack>
        </>
    );
};

export default Food;
